export default {
  complete: "Completado",
  confirmed: "Confirmado",
  pending: "Pendiente",
  cancelled: "Cancelado",
  ongoing: "En curso",
};
